module.exports = __webpack_public_path__ + "static/media/enable-boost-core.e361f5d1.png";